import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-trophy-line text-xl text-white"></i>
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-white to-teal-200 bg-clip-text text-transparent">
                CrowdRounds
              </span>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Objective app intelligence powered by structured evaluation systems — built for founders who need clarity, not guesswork.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-all duration-300">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-all duration-300">
                <i className="ri-linkedin-box-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-all duration-300">
                <i className="ri-github-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Intelligence Tiers */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Intelligence Tiers</h4>
            <ul className="space-y-3">
              <li>
                <a href="/tier1-quick-pulse" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Tier 1 – Quick Pulse™
                </a>
              </li>
              <li>
                <a href="/tier2-market-readiness" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Tier 2 – Market Readiness™
                </a>
              </li>
              <li>
                <a href="/tier3-competitive-intelligence" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Tier 3 – Competitive Intelligence™
                </a>
              </li>
              <li>
                <a href="/tier4-success-blueprint" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Tier 4 – Success Blueprint™
                </a>
              </li>
              <li>
                <a href="/tier5-full-success-intelligence" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Tier 5 – Full Success Intelligence™
                </a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Products</h4>
            <ul className="space-y-3">
              <li>
                <a href="/credit-score" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  App Credit Score™
                </a>
              </li>
              <li>
                <a href="/app-passport-viewer" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  App Passport™
                </a>
              </li>
              <li>
                <a href="/app-wars" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  App Wars™
                </a>
              </li>
              <li>
                <a href="/add-ons" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Add-Ons & Upgrades
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="/about" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  About Us
                </a>
              </li>
              <li>
                <a href="/team" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Meet Our Team
                </a>
              </li>
              <li>
                <a href="/methodology" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Our Methodology
                </a>
              </li>
              <li>
                <a href="/case-studies" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Case Studies
                </a>
              </li>
              <li>
                <a href="/contact" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a href="/how-it-works" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  How It Works
                </a>
              </li>
              <li>
                <a href="/faq" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  FAQ
                </a>
              </li>
              <li>
                <a href="/sample-report" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Sample Report
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="text-slate-300 hover:text-teal-400 transition-colors duration-200 text-sm flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-400"></i>
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              CrowdRounds® — App Success Intelligence™
            </p>
            <p className="text-sm text-gray-400">
              © 2025 CrowdRounds. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
